module.exports = __webpack_public_path__ + "static/media/kishore-pro.a014a6f0.png";